import forEach from 'lodash/forEach'

const _ = {forEach}

const objToFormData = function(FormData, data, name){
    name = name || '';
    if (typeof data === 'object'){
        _.forEach(data, (value, index) => {
            if (typeof index.indexOf !== 'function' || index.indexOf('$') !== 0) {
                if (name == ''){
                    objToFormData(FormData, value, index);
                } else {
                    objToFormData(FormData, value, name + '['+index+']');
                }
            }
        })
    } else {
      if (name.indexOf('$') !== 0) {
        FormData.append(name, data);
      }
    }
}

export {objToFormData}